import { useState } from "react";
import { createProcurementGRN, deletePGRNFileById, deleteProcurementGRNById, getProcurementGRN, getProcurementGRNById, getProcurementGRNMaterials, getProcurementMRR, updateProcurementGRN } from "../../../Services/ProcurementGRNService";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../constants";

export const useProcurementGRN = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchAllProcurementGRNs = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getProcurementGRN({
        ...params,
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.PGRN_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.PGRN_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchProcurementGRNMaterials = async (GRNId, params) => {
    try {
      const response = await getProcurementGRNMaterials(GRNId, params);
      if (response.status === 200) {
        return response.data.results;
      } else {
        toast.error(TOAST_MESSAGES.PGRN_FETCH_FAILED_MATERIALS);
        return null;
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.PGRN_FETCH_FAILED_MATERIALS);
      return null;
    }
  };

  const fetchProcurementGRNById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getProcurementGRNById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.PGRN_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.PGRN_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const newProcurementGRN = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await createProcurementGRN(payload);
      if (response.status === 201) {
        data = response.data;
        const msg = TOAST_MESSAGES.PGRN_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.PGRN_CREATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.PGRN_CREATE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateProcurementGRNDetails = async (GRNId, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await updateProcurementGRN(GRNId, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = TOAST_MESSAGES.UPDATE_PGRN_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.UPDATE_PGRN_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_PGRN_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteProcurementGRN = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await deleteProcurementGRNById(id);
      if (response.status === 200) {
        toast.success(TOAST_MESSAGES.PGRN_DELETE);
        data = true;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.FAILED_TO_DELETE_PGRN;
        toast.error(msg);
        data = false;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_TO_DELETE_PGRN
      );
      data = false;
    } finally {
      setLoading(false);
      return data;
    }
  };

    const deleteInvoice = async (id, file) => {
      setLoading(true);
      var data = null;
      try {
        const response = await deletePGRNFileById(id);
        if (response.status === 200) {
          toast.success(TOAST_MESSAGES.FILE_DELETE_SUCCESS);
          data = true;
        } else {
          const msg =
            extractErrorMessage(response) ||
            TOAST_MESSAGES.FILE_DELETE_FAIL;
          toast.error(msg);
          data = false;
        }
      } catch (error) {
        toast.error(
          extractErrorMessage(error) || TOAST_MESSAGES.FILE_DELETE_FAIL
        );
        data = false;
      } finally {
        setLoading(false);
        return data;
      }
    };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchAllProcurementGRNs,
    deleteProcurementGRN,
    newProcurementGRN,
    fetchProcurementGRNById,
    updateProcurementGRNDetails,
    fetchProcurementGRNMaterials,
    deleteInvoice,
  };
};
